<template>
  <div id="container">
    <div class="item-box-content" style="height: 148px;">
      <div>
        <span class="bold"></span>
        <span class="basic">报缺信息</span>
      </div>
      <el-form style="margin-top:20px;">
        <el-row>
          <el-col :span="16">
            <el-form-item label="报缺原因：" label-width="85px">
              <el-input type="textarea" :rows="5" placeholder="请填写报缺理由" v-model="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div>
        <span class="bold"></span>
        <span class="basic">产品清单</span>
      </div>
      <el-row :gutter="20">
        <!--------------------------------------- 已发货产品 -------------------------------------->
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">已发货产品</div>
            <el-table
              border
              :data="productList"
              :header-cell-style="tableHeader"
              empty-text="产品已全部移入报缺区！"
              v-loading="loadingProTable"
              height="456px"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionImm"
              @row-dblclick="dblclickL"
            >
              <el-table-column fixed type="selection" width="45"></el-table-column>
              <el-table-column fixed label="品牌" prop="brandName" width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="型号" show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
              <el-table-column label="货期" width="90">
                <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
              </el-table-column>
              <el-table-column prop="count" label="数量" width="80"></el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="immigrateAll">全部移入</el-button>
              <el-button type="primary" @click="immigrate" plain>移入报缺区</el-button>
            </el-col>
          </div>
        </el-col>
        <!--------------------------------------- 报缺区 -------------------------------------->
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">报缺区</div>
            <el-table
              border
              :data="repAvacList"
              :header-cell-style="tableHeader"
              height="456px"
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionRe"
              empty-text="请选择报缺产品！"
              @row-dblclick="dblclickR"
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column fixed label="品牌" prop="brandName" width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="seriesName" label="系列" width="80" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="型号" show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
              <el-table-column label="货期" width="90">
                <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
              </el-table-column>
              <el-table-column label="数量" width="125" fixed="right">
                <template slot-scope="scope">
                  <el-input-number
                    style="width:100%"
                    controls-position="right"
                    v-model="scope.row.count"
                    @change="handleNumber(scope.row)"
                    :min="1"
                    :max="scope.row.max"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="onRemoveAll">全部移出</el-button>
              <el-button type="primary" @click="onRemove" plain>移出报缺区</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button @click="onSponsor" type="primary">发起报缺</el-button>
    <!------------ 发起报缺 ------------>
    <open-or-close
      ref="OpenOrClose"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import {
  orderContractLack,
  getOrderContLackDeliverConById
} from '@/api/sell/sellManage'
export default {
  components: {
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      textarea: '', // 报缺原因
      loadingProTable: false, // 产品清单列表区loding
      repAvacList: [], // 报缺区列表
      tempLise: [], // 报缺区   选中列表
      productList: [], // 已发货产品列表
      tempWaitLise: [], // 已发货产品 选中列表
      content: '确定提交报缺？',
      title: '发起报缺'
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 发起报缺
    onSponsor() {
      if (this.repAvacList.length < 1) {
        this.$message.error('请设置报缺产品! ')
        return
      }
      if (!this.textarea) {
        this.$message.error('请填写报缺理由! ')
        return
      }
      this.$refs.OpenOrClose.onInitial()
    },
    // 确定发起报缺
    onUpdataState() {
      const params = {
        mark: this.textarea,
        ocbId: this.$route.query.id,
        orderContractLackContentList: this.repAvacList
      }
      orderContractLack(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('提交成功，请耐心等待上级审核！')
            this.$router.push({
              name: 'contractEdit',
              query: {
                id: this.$route.query.id,
                cusId: this.$route.query.cusId
              }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getList() {
      getOrderContLackDeliverConById(this.$route.query.id)
        .then((res) => {
          if (res.data.code === 200) {
            res.data.obj.forEach((ele) => {
              ele.max = ele.count
            })
            this.productList = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // -------------------   产品清单   ----------------
    dblclickR(row) {
      this.tempLise = [row]
      this.onRemove()
    },
    onRemoveAll() {
      // 全部移出
      this.tempLise = JSON.parse(JSON.stringify(this.repAvacList))
      this.onRemove()
    },
    onRemove() {
      // 移出报缺区
      if (this.tempLise.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.tempLise.forEach(m => {
          m.count = m.max
          const i = this.productList.findIndex(n => n.id === m.id)
          if (i === -1) {
            this.productList.push(m)
          } else {
            this.productList.splice(i, 1, m)
          }
          const int = this.repAvacList.findIndex(n => n.id === m.id)
          this.repAvacList.splice(int, 1)
        })
        this.tempLise = []
      }
    },
    handleSelectionRe(val) {
      this.tempLise = val
    },
    handleNumber(row) {
      // 计数器加减
      if (!row.count) {
        this.dblclickR(row)
        return
      }
      const num = row.max - row.count
      if (num === 0) {
        this.productList.forEach((ele, index) => {
          if (ele.id === row.id) {
            this.productList.splice(index, 1)
          }
        })
      } else {
        let isParam = false
        for (let i = 0; i < this.productList.length; i++) {
          if (this.productList[i].id === row.id) {
            isParam = true
            this.productList[i].count = num
          }
        }
        if (!isParam) {
          const params = JSON.parse(JSON.stringify(row))
          params.count = num
          this.productList.push(params)
        }
      }
    },
    handleSelectionImm(val) {
      this.tempWaitLise = val
    },
    dblclickL(row) {
      this.tempWaitLise = [row]
      this.immigrate()
    },
    immigrate() {
      // 移入报缺区
      if (this.tempWaitLise.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.tempWaitLise.forEach(m => {
          m.count = m.max
          const i = this.repAvacList.findIndex(n => n.id === m.id)
          if (i === -1) {
            this.repAvacList.push(m)
          } else {
            this.repAvacList.splice(i, 1, m)
          }
          const int = this.productList.findIndex(n => n.id === m.id)
          this.productList.splice(int, 1)
        })
        this.tempWaitLise = []
      }
    },
    immigrateAll() {
      // 全部移入
      this.tempWaitLise = JSON.parse(JSON.stringify(this.productList))
      this.immigrate()
    },
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
